import { makeStyles } from '@material-ui/core/styles';
import { getLargeDrawerPaperStyles } from 'UI/constants/styles';

export const useStyles = makeStyles(theme => ({
  resume: {
    paddingRight: theme.spacing(3),
    '& > *': {
      marginBottom: theme.spacing(3),
      padding: theme.spacing(3),
      width: '100%',
      backgroundColor: theme.palette.secondary.FP100,
      boxShadow:
        '0px 1px 4px rgba(3, 13, 40, 0.12), 0px 2px 2px -4px rgba(3, 13, 40, 0.08), 0px 1px 3px rgba(3, 13, 40, 0.03)',
      borderRadius: 4
    },
    '&:last-child': {
      marginBottom: 0
    }
  },
  details: {
    '& > *': {
      marginBottom: theme.spacing(1)
    },
    '& > :last-child': {
      marginBottom: 0
    }
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  detailValue: {
    fontWeight: 500
  },
  searchProjectLink: {
    width: 'fit-content'
  },
  chart: {
    overflow: 'hidden'
  },
  drawerRoot: {
    ...getLargeDrawerPaperStyles(theme),
    overflowY: 'hidden'
  },
  infoSnackbar: {
    marginBottom: theme.spacing(2.5)
  },
  actionButtons: {
    display: 'flex'
  }
}));
